import { render, staticRenderFns } from "./FloatingTabItem.vue?vue&type=template&id=2b430287&scoped=true"
import script from "./FloatingTabItem.vue?vue&type=script&lang=ts"
export * from "./FloatingTabItem.vue?vue&type=script&lang=ts"
import style0 from "./FloatingTabItem.vue?vue&type=style&index=0&id=2b430287&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b430287",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b430287')) {
      api.createRecord('2b430287', component.options)
    } else {
      api.reload('2b430287', component.options)
    }
    module.hot.accept("./FloatingTabItem.vue?vue&type=template&id=2b430287&scoped=true", function () {
      api.rerender('2b430287', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FloatingTabs/FloatingTabItem.vue"
export default component.exports